'use strict';

function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if(year < 100){
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

function dateToDateString(value){
  var result = new Date(value);
  var dd = result.getDate();
  var mm = result.getMonth() + 1; //January is 0

  var yyyy = result.getFullYear();

  var today = dd + '/' + mm + '/' + yyyy;
  return today;
};

export default class {
	/*@ngInject*/
	constructor($http, JSONToCSVConvertor){
		this.$http = $http;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
    this.filteredTimesheets = [];
    this.total = 0;
	}

	$onInit(){
		this.loadData();
	}

  createCSV(timesheets){
    timesheets = timesheets.map(timesheet => {
      timesheet.studentFullName = this.studentName(timesheet.studentID);

      return timesheet
    })

    timesheets = timesheets.map(timesheet => {
      return {
        studentFullName: timesheet.studentFullName,
        weekEnding: timesheet.weekEnding,
        rateType: timesheet.rateType,
        hours: timesheet.hours,
        
        
      }
    })

    this.JSONToCSVConvertor(timesheets, `Tutor_Hours-${this.selected.nameFirst}_${this.selected.nameLast}`, true);
  }

  loadData(){
    this.$http.get('/api/students').then(res => {
      this.students = res.data;
    })

    this.$http.get('/api/tutors').then(res => {
      this.tutors = res.data;
      this.tutors = this.tutors.map(tutor => {
        tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;
        return tutor;
      })
    })

    this.$http.get('/api/timesheets').then(res => {
      this.timesheets = res.data;
    })
  }

  studentName(studentID){
		const student = this.students.find(student => student.studentID === studentID);
		return student.nameFirst + ' ' + student.nameLast;

	}

  create(){

    this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID).then(res => {
      var filtered = res.data;
      if(this.startDate){
        filtered = filtered.filter(timesheet => {
          const tsDate =  dateStringToDate(timesheet.weekEnding)

          return this.startDate.getTime() < tsDate.getTime();
        })
      }

      if(this.endDate){
        filtered = filtered.filter(timesheet => {
          const tsDate =  dateStringToDate(timesheet.weekEnding)

          return this.endDate.getTime() > tsDate.getTime();
        })
      }

      //sort the timesheets, most recent displayed highest
      filtered = filtered.sort((a,b) => {
        const tsDateA = dateStringToDate(a.weekEnding);
        const tsDateB = dateStringToDate(b.weekEnding);

        return tsDateB.getTime() - tsDateA.getTime();
      })

      this.filteredTimesheets = filtered;

      var total = 0;
      this.filteredTimesheets.forEach(timesheet => total += timesheet.hours);
      this.total = total;
    })

  	
  }
}


// WEBPACK FOOTER //
// ./client/app/reports/tutor-hours/tutor-hours.controller.js